import script from "./StoriesMainSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./StoriesMainSlider.vue?vue&type=script&setup=true&lang=js"

import "./StoriesMainSlider.vue?vue&type=style&index=0&id=ba77550e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba77550e"]])

export default __exports__